import React from 'react';
import { Modal, Box, Button } from "@cloudscape-design/components";

/**
 * Modal para mostrar el resultado de una operación
 */
export default function ResultModal({
  visible,
  onDismiss,
  result,
  t
}) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t("insights.postRequestResult")}
      footer={
        <Box float="right">
          <Button onClick={onDismiss} variant="primary">
            {t("common.ok")}
          </Button>
        </Box>
      }
    >
      <p>{result}</p>
    </Modal>
  );
}

